import { IListTimeAssignmentsResponse } from '@/api/timeAssignments/types';

export function hasEstimatedChanges(
  editedEstimatedTimes: { [taskId: string]: { [date: string]: number } },
  item: IListTimeAssignmentsResponse
) {
  for (const [taskAssignmentId, dates] of Object.entries(editedEstimatedTimes)) {
    const assignment = item.assignments.find(a => a.task_assignment_id === taskAssignmentId);
    if (!assignment) continue;
    for (const [date, value] of Object.entries(dates)) {
      const schedule = assignment.schedules.find(s => s.scheduleDate.substring(0, 10) === date);
      const original = schedule ? Number(schedule.estimated_time) : 0;
      if (Number(value) !== original) {
        return true;
      }
    }
  }
  return false;
}

export function hasRealTimeChanges(
  editedRealTimes: { [scheduleId: string]: number },
  item: IListTimeAssignmentsResponse
) {
  // Construye un set de todos los ids de schedules actuales
  const existingScheduleIds = new Set<string>();
  for (const assignment of item.assignments) {
    for (const schedule of assignment.schedules) {
      existingScheduleIds.add(schedule.id);
    }
  }

  for (const [scheduleId, value] of Object.entries(editedRealTimes)) {
    if (!existingScheduleIds.has(scheduleId)) {
      // Si el schedule ya no existe, ignóralo
      continue;
    }
    let original = 0;
    for (const assignment of item.assignments) {
      const schedule = assignment.schedules.find(s => s.id === scheduleId);
      if (schedule) {
        original = Number(schedule.real_time) || 0;
        break;
      }
    }
    if (Number(value) !== original) {
      return true;
    }
  }
  return false;
}